import config from './config';
import memoize from '../utils/fp/memoize';
import buildUrl from '../utils/url/buildUrl';
import fetchJSON from '../utils/fetch/fetchJSON';

/**
 * @public
 * Gets the logos of carriers and optionally, the total plans and prices by state.
 *
 * @param  {Object} params: an object with the data arguments to send to the service, e.g. {siteName, stateAcronym}
 * @param  {Boolean} seePlans: determines whether the response should contain the total plans and prices by state.
 * @return {Promise}
 */
function getCompanyLogos(params, seePlans) {
  const url = seePlans
    ? config.companyPlansLogos
    : config.companyLogos;

  if (params.shortName) {
    params.siteName = params.shortName;
    delete params.shortName;
  }

  return fetchJSON(
    buildUrl(url, params),
    {
      method: 'GET',
      data: params,
      processData: false,
    });
}

export default memoize(getCompanyLogos);
